import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import {
  BackButton,
  ThinTextField,
  ThinDropdown,
  AddButton,
} from "../../common/GeneralComponent";
import Loader from "../../../components/partials/Loader";
import { fetchData } from "../../../utils/functions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const EditFeatureSubType = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(true);
  const [features, setFeatures] = useState([]);

  const formik = useFormik({
    initialValues: {
      feature_sub_type: "",
      feature_id: "",
      status: 1,
    },
    validationSchema: Yup.object({
      feature_sub_type: Yup.string()
        .required("Feature Sub Type name is required")
        .min(3, "Must be at least 3 characters")
        .max(100, "Feature Sub Type must be 100 characters or less"),
      feature_id: Yup.number()
        .required("Feature is required")
        .typeError("Feature is required"),
      status: Yup.number()
        .oneOf([0, 1], "Invalid status")
        .required("Status is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);

        const payload = {
          feature_sub_type_id: parseInt(id), // make sure it's number
          feature_sub_type: values.feature_sub_type,
          feature_id: parseInt(values.feature_id),
          status: parseInt(values.status),
          updated_by: 1, // Optional: set from auth if needed
        };

        const response = await fetchData(
          `subtypes`,
          "PUT",
          payload,
          {},
          {},
          navigate,
          "/subtypes",
          dispatch
        );

        toast.success(response.message);
        navigate("/subtypes");
      } catch (error) {
        toast.error(error.message || "Failed to update");
      } finally {
        setLoader(false);
      }
    },
  });

  // Fetch the feature sub-type details for editing
  const fetchSubType = async () => {
    try {
      const response = await fetchData(
        "subtypes",
        "GET",
        null,
        {},
        { id },
        navigate,
        "/subtypes",
        dispatch
      );

      const data = response?.data;
      if (data) {
        formik.setValues({
          feature_sub_type: data.feature_sub_type,
          feature_id: parseInt(data.feature_id),
          status: parseInt(data.status),
        });
      } else {
        toast.error("Feature Sub Type not found");
        navigate("/subtypes");
      }
    } catch (err) {
      toast.error("Error fetching sub-type");
    } finally {
      setLoader(false);
    }
  };

  // Fetch all available features
  const fetchFeatures = async () => {
    try {
      const response = await fetchData(
        "features",
        "GET",
        null,
        {},
        {},
        navigate,
        "/subtypes",
        dispatch
      );
      setFeatures(response?.data || []);
    } catch (error) {
      toast.error("Failed to load feature list");
    }
  };

  useEffect(() => {
    fetchFeatures();
    fetchSubType();
  }, []);

  return (
    <div>
      {loader && <Loader />}
      {/* <BackButton to="/subtypes" text="Back" />
      <h1 className="text-black text-[1.475rem] text-Black font-[Bold] ">
        Edit Feature Sub Type
      </h1> */}

       <div className="flex  flex-col lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
                                        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
                                                     Edit Feature Sub Type
                                                 </h1>
                                        <BackButton text="Back" to="/subtypes" />
                                             </div>
      <div  className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Edit Feature Sub Type
          </h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="p-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 p-4 items-center">
            {/* Feature Sub Type Field */}
            <div className="py-[0.25rem]">
              <ThinTextField
                label="Feature Sub Type"
                name="feature_sub_type"
                value={formik.values.feature_sub_type}
                onChange={formik.handleChange}
              />
              {formik.touched.feature_sub_type &&
                formik.errors.feature_sub_type && (
                  <p className="text-sm text-red-500 mt-1">
                    {formik.errors.feature_sub_type}
                  </p>
                )}
            </div>


            {/* Feature Dropdown */}
            <div>
              <ThinDropdown
                label="Feature"
                name="feature_id"
                options={features.map((f) => ({
                  value: f.feature_id,
                  label: `${f.feature_name}`,
                }))}
                value={formik.values.feature_id}
                onChange={(e) =>
                  formik.setFieldValue("feature_id", e.target.value === "" ? "" : parseInt(e.target.value))
                }
              />
              {formik.touched.feature_id && formik.errors.feature_id && (
                <p className="text-sm text-red-500 mt-1">
                  {formik.errors.feature_id}
                </p>
              )}
            </div>

            {/* Status Dropdown */}
            <div>
              <ThinDropdown
                label="Status"
                name="status"
                options={[
                  { value: 1, label: "Active" },
                  { value: 0, label: "Inactive" },
                ]}
                value={formik.values.status}
                onChange={(e) =>
                  formik.setFieldValue("status", parseInt(e.target.value))
                }
              />
              {formik.touched.status && formik.errors.status && (
                <p className="text-sm text-red-500 mt-1">
                  {formik.errors.status}
                </p>
              )}
            </div>
          </div>
          <div className='p-4'>
            <AddButton text="Submit" type="Submit" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditFeatureSubType;
